var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIChargingCableMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39,14h-1V6h-2v8h-8V6h-2v8h-1c-1.6542969,0-3,1.3457031-3,3v10c0,1.6542969,1.3457031,3,3,3h6v2.5 C31,38.8408203,25.8413086,44,19.5,44S8,38.8408203,8,32.5V16C8,9.3828125,13.3833008,4,20,4V2C12.2802734,2,6,8.2802734,6,16v16.5 C6,39.9443359,12.0561523,46,19.5,46S33,39.9443359,33,32.5V30h6c1.6542969,0,3-1.3457031,3-3V17C42,15.3457031,40.6542969,14,39,14 z M40,27c0,0.5517578-0.4487305,1-1,1H25c-0.5512695,0-1-0.4482422-1-1V17c0-0.5517578,0.4487305-1,1-1h14 c0.5512695,0,1,0.4482422,1,1V27z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIChargingCableMedium);
export default __webpack_public_path__ + "static/media/i-charging-cable--medium.a4db2c9f4ae83b8f7c1a51fe4ab91f13.svg";
export { ForwardRef as ReactComponent };